/*
 * `DES-001`. One page chrome for the three authenticated customer surfaces.
 *
 * They shipped with three different `max-width`s — 48rem, 48rem and 32rem —
 * so the `<h1>` jumped horizontally as you moved between them (measured:
 * x=144 on Team and Price lists, x=272 on Commercial rules, at 1024px). Three
 * near-identical `.page`/`.hint`/`.sectionTitle` blocks were also copied into
 * three module files, which is how they drifted in the first place.
 */
.page {
  padding: 1.5rem var(--space-4, 1rem) 3rem;
  max-width: 48rem;
  margin: 0 auto;
}

.title {
  font-family: var(--font-display);
  margin: 0 0 0.25rem;
}

.lede {
  color: var(--ink-soft);
  font-size: var(--text-min-body);
  margin: 0 0 1.5rem;
  max-width: 46ch;
}

.sectionTitle {
  font-family: var(--font-display);
  font-size: 1rem;
  margin: 2rem 0 0.75rem;
}

.card {
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: var(--radius-sharp);
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.hint {
  color: var(--muted);
  font-size: var(--text-min-body);
  margin: 0;
}

.error {
  color: var(--stop);
  font-size: var(--text-min-body);
  margin: 0;
}

/*
 * Fields in a row line up by their LABELS, not by their bottoms.
 *
 * `flex-end` looks right until two fields in the row carry hints of different
 * heights, and then it is visibly wrong: measured on the upload form, the
 * three labels sat at y=450, 466 and 490 — a 40px stagger across one row.
 * Aligning at the start pins label and input, and lets each hint hang to
 * whatever depth it needs.
 */
.formRow {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 0.75rem;
}

.formRow > * {
  flex: 1 1 12rem;
}

/*
 * The submit button has no label above it, so it needs the height of one to
 * sit level with the inputs beside it: `--text-min-mono` at the label's own
 * 1.5 line-height, plus `Input`'s own 0.25rem label-to-input gap.
 */
.formRow > .submit {
  flex: 0 0 auto;
  padding-top: calc(var(--text-min-mono) * 1.5 + 0.25rem);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

.rowAction {
  white-space: nowrap;
}

.muted {
  color: var(--muted);
}
